var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-signup__complete__caption mb-3"},[_c('div',[_vm._v("会員登録が完了しました。")]),_vm._v(" "),_c('div',[_vm._v("これから"+_vm._s(_vm.hostName)+"をどうぞよろしくお願いいたします。")])])}
var staticRenderFns = []

export { render, staticRenderFns }